@if (product(); as product) {
  <ng-template #labels>
    @if (showLabels()) {
      @if (!product.availableForSale && !customLabel?.value) {
        <span class="chip-label type-body-sm chip--outline chip--danger product-tile-label" [class.has--slider]="(media().length || 0) > 1">
          {{ 'product-tegel-uitverkocht-label' | fromDictionary }}
        </span>
      }

      @if (customLabel?.value) {
        <span
          class="chip-label type-body-sm chip--outline chip--secondary product-tile-label"
          [class.has--slider]="(media().length || 0) > 1"
        >
          {{ customLabel?.value }}
        </span>
      }
    }
  </ng-template>
  <ng-template #action>
    @if (showQuickAdd()) {
      <button class="button button--secondary button-icon button--xs product-quick-add" (click)="quickAdd()" aria-label="Add item to cart">
        <app-icon anchor="icon-plus"></app-icon>
      </button>
    }
  </ng-template>

  @if ((media().length || 0) > 1) {
    <section class="product-image-slider-container" [class.has--pagination]="showPagination()" [class.is--loading]="!loaded()">
      @if (showPagination()) {
        <nav class="product-image-slider-nav-container">
          <app-embla-slider
            #sliderNavEl
            [slides]="media()"
            [options]="{ loop: false, dragFree: false, skipSnaps: true, dragThreshold: 10, axis: 'y' }"
            [showArrows]="false"
            [showDots]="false"
            class="embla-carousel-y-axis product-image-slider-nav"
          >
            @for (item of media(); track item) {
              <div class="slide">
                <button
                  class="d-block product-image-slider-nav__item"
                  [class.is--active]="$index === activeSlide()"
                  (click)="sliderEl.scrollToSlide($index)"
                >
                  @if (!loaded()) {
                    <span class="skeleton-loading-product-image"></span>
                  }
                  <app-shopify-media-item [mediaItem]="item" [previewImage]="true" [sizes]="{ sm: 1 }"></app-shopify-media-item>
                </button>
              </div>
            }
          </app-embla-slider>

          @if (sliderNav()?.canScrollNext()) {
            <button
              class="button button-outline button-icon button--secondary slider-pagination-indicator-next button--xs"
              type="button"
              (click)="sliderNav()?.next()"
              aria-label="Meer miniaturen tonen"
            >
              <app-icon anchor="icon-plus"></app-icon>
            </button>
          }

          @if (media() && media().length > 1) {
            <div class="product-image-slider-nav--mobile type-body-sm mx-1 d-md-none">
              <strong>{{ activeSlide() + 1 }}&nbsp;</strong>
              <span>/ {{ media().length }}</span>
            </div>
          }
        </nav>
      }

      <div class="product-image-slider" [ngClass]="showPagination() ? 'col-md-10' : ''">
        <ng-container *ngTemplateOutlet="labels"></ng-container>
        <ng-container *ngTemplateOutlet="action"></ng-container>

        <app-embla-slider
          #sliderEl
          [slides]="media()"
          [options]="{ loop: false, dragFree: false, skipSnaps: true, dragThreshold: 10 }"
          [showArrows]="false"
          [showDots]="false"
          (slideChange)="activeSlide.set($event)"
        >
          @for (item of media(); track item) {
            <div class="slide">
              @if (hasLink()) {
                <fstr-link
                  [showText]="false"
                  [button]="{
                    text: '',
                    url: '',
                    routerLink: hasLink()
                      ? collectionHandle()
                        ? ['/', 'collections', collectionHandle()!, product.handle]
                        : ['/', 'products', product.handle]
                      : [],
                  }"
                >
                  <app-shopify-media-item
                    [mediaItem]="item"
                    [fallbackAlt]="product.title + ' variant foto ' + $index"
                    [playVideo]="$index === activeSlide()"
                    [sizes]="sizes()"
                  ></app-shopify-media-item>
                </fstr-link>
              } @else {
                <app-shopify-media-item
                  [mediaItem]="item"
                  [fallbackAlt]="product.title + ' variant foto ' + $index"
                  [playVideo]="$index === activeSlide()"
                  [sizes]="sizes()"
                ></app-shopify-media-item>
              }
            </div>
          }
        </app-embla-slider>

        <button
          class="product-image-slider__control is--prev"
          [class.set--inactive]="!slider()?.canScrollPrev()"
          (click)="slider()?.prev()"
          aria-label="Vorige foto"
        >
          <app-icon anchor="icon-chevron-left-xs"></app-icon>
        </button>

        <button
          class="product-image-slider__control is--next"
          [class.set--inactive]="!slider()?.canScrollNext()"
          (click)="slider()?.next()"
          aria-label="Volgende foto"
        >
          <app-icon anchor="icon-chevron-right-xs"></app-icon>
        </button>
      </div>
    </section>
  } @else {
    <ng-container *ngTemplateOutlet="labels"></ng-container>
    <ng-container *ngTemplateOutlet="action"></ng-container>
    @if (hasLink()) {
      <fstr-link
        [showText]="false"
        [button]="{
          text: '',
          url: '',
          routerLink: collectionHandle() ? ['/', 'collections', collectionHandle()!, product.handle] : ['/', 'products', product.handle],
        }"
      >
        <app-shopify-media-item
          [mediaItem]="media()[0]"
          [fallbackAlt]="product.title"
          [playVideo]="true"
          [sizes]="sizes()"
        ></app-shopify-media-item>
      </fstr-link>
    } @else {
      <app-shopify-media-item
        [mediaItem]="media()[0]"
        [fallbackAlt]="product.title"
        [playVideo]="true"
        [sizes]="sizes()"
      ></app-shopify-media-item>
    }
  }
}
